import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import {
  getMenuSectionTitlesTypography,
  getHeroTextColor
} from 'styles/helpers/getThemeStyles';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const StyledHeroHeading = styled(Typography, {
  shouldForwardProp: muiPropForwarding('hasHeroImage')
})(({ theme, hasHeroImage }) => {
  let fontStyles = {};
  let color = theme.palette.white;
  fontStyles = {
    letterSpacing: 0.25,
    ...getMenuSectionTitlesTypography(theme)
  };
  color = getHeroTextColor(theme, hasHeroImage);
  return {
    color,
    fontSize: 36,
    ...fontStyles,
    [theme.breakpoints.down('md')]: {
      fontSize: 20
    }
  };
});

const HeroHeading = ({ children, hasHeroImage }) => {
  return (
    <StyledHeroHeading hasHeroImage={hasHeroImage} variant="h1" align="center">
      {children}
    </StyledHeroHeading>
  );
};

HeroHeading.propTypes = {
  children: PropTypes.string,
  hasHeroImage: PropTypes.bool
};

export default HeroHeading;
